<template>
  <div id="reserve-table">
    <div class="adaptive-column-content">
      <content-loader title="Пожалуйста, подождите, мы загружаем информацию о ресторане" v-if="restaurants.length === 0" />
      <template v-else>
        <h2 class="form">Бронирование столика на&nbsp;{{ restaurant.acf.short_address }}</h2>
        <form id="order-form">
          <div class="delivery-fields">
            <div class="row phone">
              <input-container type="tel" label="Телефон" inputId="phone" :required="true" v-model="form.phone" @input="onPhoneInput" :class="{ 'has-error': $v.form.phone.$error }" />
              <input-container type="number" label="Число персон" inputId="people" :required="true" v-model="form.people" :class="{ 'has-error': $v.form.people.$error }" />
            </div>
            <input-container label="Имя" inputId="name" :required="true" v-model="form.name" :class="{ 'has-error': $v.form.name.$error }" />
            <input-container type="textarea" v-model="form.comment" label="Комментарий" inputId="comment" />
          </div>
          <mangal-button class="red" :loading="isLoading" @click.native="processSubmit" text="Забронировать" />
          <div class="error-message" v-if="reserveFailed">Извините, произошла ошибка при попытке забронировать столик. Мы уже занимаемся решением данной проблемы. Пожалуйста, позвоните нам по номеру <phone />, чтобы мы могли помочь Вам!</div>
        </form>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Phone from '/src/components/Phone'
  import ContentLoader from '/src/components/ContentLoader'
  import InputContainer from '/src/components/InputContainer'
  import MangalButton from '/src/components/MangalButton'
  import { find } from 'lodash'

  import { required } from 'vuelidate/lib/validators'
  import Velocity from 'velocity-animate'

  export default {
    name: 'ReserveTablePage',
    components: {
      ContentLoader,
      InputContainer,
      MangalButton,
      Phone
    },
    data () {
      return {
        isLoading: false,
        form: {
          phone: '+7 (',
          people: 1,
          name: '',
          comment: ''
        },
        reserveFailed: false
      }
    },
    validations () {
      return {
        form: {
          phone: {
            required,
            notEmpty: input => !(input === '+7 ('),
            // hasNine: input => ((input.length >= 4 && +input[INDEX_OF_NINE] === 9) || input.length <= 4),
            format: input => input.length > 4 ? /\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/.test(input) : true
          },
          people: {
            required
          },
          name: {
            required
          }
        }
      }
    },
    methods: {
      ...mapActions({
        loadRestaurants: 'content/loadRestaurants',
        reserveTable: 'reserveTable'
      }),
      onPhoneInput (value) {
        if (value !== '+7 (' && value) {
          this.form.phone = value
        } else {
          this.form.phone = value
          // this.$v.phone.$reset()
        }
      },
      processSubmit () {
        if (this.$v.form.$invalid) {
          this.$v.form.$touch()
          Velocity(document.getElementById('order-form'), 'scroll', {
            duration: 300,
            offset: -document.getElementById('site-header').offsetHeight - 10
          })
        } else {
          this.reserveFailed = false
          this.isLoading = true

          this.form.restaurant = this.restaurant.acf.short_address

          this.reserveTable(this.form).then((body) => {
            this.$router.push({ name: 'SuccessPage', params: { type: 'reserve' } })
          }).catch((e) => {
            console.log('e', e)
            this.reserveFailed = true
          }).finally(() => {
            this.isLoading = false
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        restaurants: 'content/restaurants'
      }),
      restaurantSlug () {
        return this.$route.params.restaurant
      },
      restaurant () {
        return find(this.restaurants, (r) => {
          return r.slug === this.restaurantSlug
        })
      }
    },
    mounted () {
      this.loadRestaurants()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/index/ReserveTable.vue